import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface Props {
  children: string;
  /** Render compact (smaller margins / smaller headings) — e.g. inside .resolution-summary */
  compact?: boolean;
}

/**
 * Markdown renderer matching the Arkturian portfolio flat theme.
 *
 * - Headings: Roboto Flex, light weight, modest sizes (issue title is the
 *   real h1, in-description headings must not compete)
 * - Inline code + code fences: JetBrains Mono on a subtle gray surface
 * - Lists: tight spacing, accent color for ordered list numbers
 * - Tables: full-width with light borders (GFM)
 * - Links: red accent, underline on hover
 */
export function Markdown({ children, compact = false }: Props) {
  return (
    <div className={`md ${compact ? 'md-compact' : ''}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
